"use client";
/*
 * Documentation:
 * OW_ProjectCard — https://app.subframe.com/4f62853ee923/library?component=OW_ProjectCard_6aec39be-22ef-48ae-ae24-244b1b4f8948
 */

import React from "react";
import * as SubframeUtils from "../utils";

interface Ow_ProjectCardRootProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, "title"> {
  title?: React.ReactNode;
  description?: React.ReactNode;
  children?: React.ReactNode;
  accent?: boolean;
  className?: string;
}

const Ow_ProjectCardRoot = React.forwardRef<
  HTMLDivElement,
  Ow_ProjectCardRootProps
>(function Ow_ProjectCardRoot(
  {
    title,
    description,
    children,
    accent = false,
    className,
    ...otherProps
  }: Ow_ProjectCardRootProps,
  ref
) {
  return (
    <div
      className={SubframeUtils.twClassNames(
        "group/6aec39be flex w-full cursor-pointer flex-col items-start rounded-md bg-neutral-50 hover:bg-neutral-100",
        { "bg-default-background": accent },
        className
      )}
      ref={ref}
      {...otherProps}
    >
      {children ? (
        <div className="flex w-full items-center justify-center overflow-hidden rounded-t-md aspect-[6/4]">
          {children}
        </div>
      ) : null}
      <div className="flex w-full flex-col items-start gap-2 px-6 py-6">
        {title ? (
          <span className="text-heading-4 font-heading-4 text-neutral-900">
            {title}
          </span>
        ) : null}
        {description ? (
          <span className="text-caption font-caption text-neutral-500">
            {description}
          </span>
        ) : null}
      </div>
    </div>
  );
});

export const Ow_ProjectCard = Ow_ProjectCardRoot;
